<template>
  <form-group class="date-time-picker"
              :label="label"
              :errors="internalErrors"
              :required="required"
              @focus="focus">
    <div class="date-time-picker__container uk-inline">
      <input readonly
             ref="primaryInput"
             class="date-time-picker__input uk-input"
             :class="inputCss"
             :value="internalValue"
             :placeholder="this.placeholder"
             :disabled="disabled">
      <a href="#" class="uk-form-icon uk-form-icon-flip" @click.prevent="clear">
        <icon name="close" />
      </a>
    </div>
  </form-group>
</template>

<script>
import Flatpickr from 'flatpickr';
import Input from '@/mixins/Input';
import TextInput from '@/components/TextInput';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';

export default {
  name: 'date-time-picker',
  mixins: [Input],
  props: {
    value: String,
    placeholder: String,
    min: String,
    max: String,
    required: Boolean,
  },
  components: {
    TextInput,
  },
  data() {
    return {
      picker: null,
    };
  },
  mounted() {
    this.picker = new Flatpickr(this.$refs.primaryInput, {
      mode: 'single',
      allowInput: false,
      altInput: true,
      altFormat: 'D, d.m.Y H:i',
      enableTime: true,
      minuteIncrement: 15,
      weekNumbers: true,
      time_24hr: true,
      onOpen: () => { this.setBoundaries(); },
      onChange: (selectedDates) => {
        let datetime = selectedDates[0];
        if (datetime) datetime = datetime.toISOString();
        this.onChange(datetime);
      },
    });
    this.refreshPickerInputClasses();
    this.refreshPickerState();
  },
  updated() {
    this.refreshPickerState();
  },
  destroyed() {
    this.picker.destroy();
  },
  watch: {
    errors() {
      this.refreshPickerInputClasses();
    },
  },
  methods: {
    clear() {
      this.picker.clear();
    },
    focus() {
      this.picker.open();
    },
    blur() {
      this.picker.close();
    },
    refreshPickerInputClasses() {
      const input = this.picker.altInput;
      if (!input) return;
      Object.keys(this.inputCss).forEach((className) => {
        const active = this.inputCss[className];
        if (active) {
          input.classList.add(className);
        } else {
          input.classList.remove(className);
        }
      });
    },
    refreshPickerState() {
      this.picker.setDate(this.internalValue);
      this.setBoundaries();
    },
    setBoundaries() {
      this.picker.set('minDate', this.min);
      this.picker.set('maxDate', this.max);
    },
    onChange(value) {
      this.internalValue = value || null;
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.date-time-picker__container {
  display: block;
}

.date-time-picker__input {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?4e2af510